import { Card, Checkbox, Elevation, Radio, RadioGroup, RangeSlider } from "@blueprintjs/core";
import { faChevronDown, faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import fetch from "node-fetch";
import queryString from 'query-string';
import React, { Fragment } from 'react';
import { Link, withRouter } from 'react-router-dom';
import arrayUtils from '../../../utils/array';
import Page from '../../components/page';
import SearchResultCard from '../../containers/searchResultCard';


const bedroomList = [
  { id: '1', bhk: '1BHK' },
  { id: '2', bhk: '2BHK' },
  { id: '3', bhk: '3BHK' },
  { id: '4', bhk: '4BHK' },
  { id: '5', bhk: '5BHK' }
];

const bathroomListDefault = [
  { id: '1', bath: '1' },
  { id: '2', bath: '2' }
]

const tenantType = [
  { id: 'Family', tenant: 'Family' },
  { id: 'Bachelor', tenant: 'Bachelor' },
];

const furnishedType = [
  { id: 'Furnished', furnishing: 'Furnished' },
  { id: 'SemiFurnished', furnishing: 'Semi Furnished' },
  { id: 'Empty', furnishing: 'Empty' }
];

class SearchResult extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sliderValue: [10000, 20000000],
      sliderInputValue: [10000, 20000000],
      bedrooms: [],
      bathrooms: [],
      amenities: [],
      searchData: null,
      customerPreference: '',
      furnishType: '',
      areaUid: null,
      amenitiesGroup: [],
      bathroomList: bathroomListDefault
    };
    this.fetchAmenities();
  }

  componentDidMount() {
    let parsedQs = queryString.parse(this.props.location.search);
    let inventoryType = this.props.match.params.propertytype;
    if (inventoryType === 'buy') inventoryType = 'sell';
    let bedrooms = parsedQs.bedrooms ? parsedQs.bedrooms.split(',') : [];
    let bathroomList = parsedQs.bedrooms ? this.calculateBedrooms(bedrooms) : bathroomListDefault;
    let bathrooms = parsedQs.bathrooms ? parsedQs.bathrooms.split(',') : [];
    let amenities = parsedQs.amenities ? parsedQs.amenities.split(',') : [];
    let customerPreference = parsedQs.customerPreference ? parsedQs.customerPreference : '';
    let furnishType = parsedQs.furnishType ? parsedQs.furnishType : '';
    let sliderValue = [];
    sliderValue.push(parseInt(parsedQs.minPrice) ? parseInt(parsedQs.minPrice) : 10000);
    sliderValue.push(parseInt(parsedQs.maxPrice) ? parseInt(parsedQs.maxPrice) : 20000000);
    let sliderInputValue = [...sliderValue];

    this.setState({
      areaUid: parsedQs.areaUid ? parsedQs.areaUid : null,
      bedrooms,
      sliderValue,
      sliderInputValue,
      bathrooms,
      amenities,
      customerPreference,
      furnishType,
      inventoryType,
      bathroomList
    }, () => {
      this.fetchProperties();
    });
  }

  fetchAmenities = () => {
    let URL = '/v1/amenities';
    fetch(URL)
      .then((response) => {
        return response.json();
      })
      .then((result) => {
        if (result.message !== 'Ok') {
          return;
        }
        this.setState({
          amenitiesGroup: arrayUtils.groupObjects(result.data, "amenityType"),
        });
      });
  }

  isFiltered = (type) => {
    switch (type) {
      case 'bedrooms':
        return (this.state.bedrooms.length > 0);
      case 'bathrooms':
        return (this.state.bathrooms.length > 0)
      case 'minPrice':
        return (this.state.sliderValue[0] > 10000)
      case 'maxPrice':
        return (this.state.sliderValue[1] < 20000000)
      case 'amenities':
        return (this.state.amenities.length > 0)
      case 'customerPreference':
        return (this.state.customerPreference.length > 0)
      case 'furnishType':
        return (this.state.furnishType.length > 0)
      default:
        return false;
    }
  }

  fetchProperties(loadMore) {
    let URL = '/v1/property/inventory/search';
    let urlQueries = [];
    urlQueries.push(`inventoryType=${this.state.inventoryType}`);
    if (this.state.areaUid) {
      urlQueries.push(`areaUid=${this.state.areaUid}`);
    }
    if (this.isFiltered('bedrooms')) {
      urlQueries.push(`bedrooms=${this.state.bedrooms.join(',')}`);
    }
    if (this.isFiltered('minPrice')) {
      urlQueries.push(`minPrice=${this.state.sliderValue[0]}`);
    }
    if (this.isFiltered('maxPrice')) {
      urlQueries.push(`maxPrice=${this.state.sliderValue[1]}`);
    }
    if (this.isFiltered('bathrooms')) {
      urlQueries.push(`bathrooms=${this.state.bathrooms.join(',')}`);
    }
    if (this.isFiltered('amenities')) {
      urlQueries.push(`amenities=${this.state.amenities.join(',')}`);
    }
    if (this.isFiltered('customerPreference')) {
      urlQueries.push(`customerPreference=${this.state.customerPreference}`);
    }
    if (this.isFiltered('furnishType')) {
      urlQueries.push(`furnishType=${this.state.furnishType}`);
    }
    URL += `?${urlQueries.join('&')}`;
    fetch(URL)
      .then((response) => {
        return response.json();
      })
      .then((result) => {
        if (result.message !== 'Ok') {
          return;
        }
        this.setState({
          searchData: result.data,
        });
      });
  }

  createUrlQueries() {
    let urlQueries = [];
    if (this.state.areaUid) {
      urlQueries.push(`areaUid=${this.state.areaUid}`);
    }
    if (this.state.bedrooms.length > 0) {
      urlQueries.push(`bedrooms=${this.state.bedrooms.join(',')}`);
    }
    if (this.state.bathrooms.length > 0) {
      urlQueries.push(`bathrooms=${this.state.bathrooms.join(',')}`);
    }
    if (this.state.customerPreference.length > 0) {
      urlQueries.push(`customerPreference=${this.state.customerPreference}`);
    }
    if (this.state.furnishType.length > 0) {
      urlQueries.push(`furnishType=${this.state.furnishType}`);
    }
    if (this.isFiltered('minPrice')) {
      urlQueries.push(`minPrice=${this.state.sliderValue[0]}`);
    }
    if (this.isFiltered('maxPrice')) {
      urlQueries.push(`maxPrice=${this.state.sliderValue[1]}`);
    }
    if (this.state.amenities.length > 0) {
      urlQueries.push(`amenities=${this.state.amenities.join(',')}`);
    }
    this.props.history.push({
      search: `?${urlQueries.join('&')}`,
    })
  }

  handleSliderChange = (range) => {
    this.setState({
      sliderValue: range,
      sliderInputValue: range
    });
  }

  handleSliderRelease = (range) => {
    this.createUrlQueries();
    this.fetchProperties(true);
  }

  calculateBedrooms = (bhkArr) => {
    let bathroomList = [];
    for (let i = parseInt(Math.min(...bhkArr)) - 1; i <= parseInt(Math.max(...bhkArr, 1)); i++) {
      if (i >= 0) {
        bathroomList.push({
          id: i.toString(), bath: i.toString()
        })
      }
    }
    return bathroomList;
  }

  handleCheckedChange(e, type) {
    let newState = { ...this.state };
    let indexOfValue = newState[type].indexOf(e.target.value);
    if (indexOfValue === -1) {
      newState[type].push(e.target.value);
    } else {
      newState[type].splice(indexOfValue, 1);
    }
    if (type === 'bedrooms') {
      if (newState[type].length) {
        newState.bathroomList = this.calculateBedrooms(newState[type]);
      } else {
        newState.bathroomList = bathroomListDefault
      }
    }
    this.setState(newState, () => {
      this.createUrlQueries();
      this.fetchProperties(true);
    });
  }

  handleRadioChange(e, type) {
    let newState = { ...this.state };
    if (newState[type] === e.target.value) {
      newState[type] = '';
    } else {
      newState[type] = e.target.value;
    }
    this.setState(newState, () => {
      this.createUrlQueries();
      this.fetchProperties(true);
    });
  }

  onSliderInputBlur = () => {
    let sliderValue = [...this.state.sliderValue];
    let sliderInputValue = [...this.state.sliderInputValue];
    if (sliderInputValue[0] > sliderValue[1]) {
      sliderInputValue[0] = sliderValue[1]
    }
    if (sliderInputValue[1] < sliderValue[0]) {
      sliderInputValue[1] = sliderValue[0]
    }
    this.setState({ sliderValue, sliderInputValue },
      () => {
        this.createUrlQueries();
        this.fetchProperties(true);
      });
  }

  changeSliderInputValue(e, type) {
    let sliderValue = [...this.state.sliderValue];
    let sliderInputValue = [...this.state.sliderInputValue];
    if (type === 'min_value') {
      sliderInputValue[0] = parseInt(e.target.value ? e.target.value : 0);
      if (sliderInputValue[0] !== sliderValue[0] && sliderInputValue[0] <= sliderValue[1]) {
        sliderValue[0] = sliderInputValue[0]
      }
    }
    if (type === 'max_value') {
      sliderInputValue[1] = parseInt(e.target.value ? e.target.value : sliderValue[1]);
      if (sliderInputValue[1] !== sliderValue[1] && sliderInputValue[1] >= sliderValue[0]) {
        sliderValue[1] = sliderInputValue[1]
      }
    }
    this.setState({ sliderValue, sliderInputValue },
      () => {
        this.createUrlQueries();
        this.fetchProperties(true);
      });
  }

  collapseSidebar = () => {
    let { filterCollapse } = this.state;
    this.setState({ filterCollapse: !filterCollapse });
  }

  render() {
    return (
      <Page id="homepage">
        <section className="section">
          <div className="container">
            <div className="columns">
              <div className="column is-narrow">
                <Card
                  className="filter-box"
                  elevation={Elevation.ONE}
                >
                  <a className="text-dark filter-header"
                    onClick={this.collapseSidebar}
                  >
                    <strong>Modify Search</strong>
                    <FontAwesomeIcon icon={faChevronDown} />
                  </a>

                  <div className={`collapsible ${this.state.filterCollapse ? "collapsed" : ""}`}>
                    <h3 className="filter-title">BHK</h3>
                    <div className="filter-options">
                      <div className="columns is-multiline">
                        {
                          bedroomList.map((item, i) => (
                            <div className="column is-6" key={item.id}>
                              <Checkbox
                                checked={this.state.bedrooms.indexOf(item.id) !== -1}
                                onChange={e => this.handleCheckedChange(e, 'bedrooms')}
                                value={item.id}>
                                {item.bhk}
                              </Checkbox>
                            </div>
                          ))
                        }
                      </div>
                    </div>

                    <h3 className="filter-title">Price Range</h3>
                    <div className="filter-options">
                      <div className="slider-container">
                        <RangeSlider
                          // min={10000}
                          max={20000000}
                          stepSize={5000}
                          value={this.state.sliderValue}
                          onChange={this.handleSliderChange}
                          onRelease={this.handleSliderRelease}
                          labelStepSize={5000}
                          labelPrecision={false}
                          labelRenderer={false}
                        />
                      </div>
                      <div className="columns">
                        <div className="column">
                          <label className="bp3-label">
                            Min
                          <input
                              placeholder="Min"
                              type="text"
                              onChange={e => this.changeSliderInputValue(e, 'min_value')}
                              onBlur={e => this.onSliderInputBlur()}
                              className="bp3-input"
                              value={this.state.sliderInputValue[0]}
                            />
                          </label>
                        </div>
                        <div className="column">
                          <label className="bp3-label">
                            Max
                          <input
                              placeholder="Max"
                              type="text"
                              onChange={e => this.changeSliderInputValue(e, 'max_value')}
                              onBlur={e => this.onSliderInputBlur()}
                              className="bp3-input"
                              value={this.state.sliderInputValue[1]}
                            />
                          </label>
                        </div>
                      </div>
                    </div>
                    {this.props.match.params.propertytype === 'buy' ?
                      <Fragment>
                        <h3 className="filter-title">Bathroom</h3>
                        <div className="filter-options">
                          <div className="columns is-multiline">
                            {
                              this.state.bathroomList.map((item, i) => (
                                <div className="column is-4" key={item.id}>
                                  <Checkbox
                                    checked={this.state.bathrooms.indexOf(item.bath) !== -1}
                                    onChange={e => this.handleCheckedChange(e, 'bathrooms')}
                                    value={item.bath}
                                  >
                                    {item.bath}
                                  </Checkbox>
                                </div>
                              ))
                            }
                          </div>
                        </div>
                        <h3 className="filter-title">Amenities</h3>
                        <div className="filter-options">
                          {
                            Object.keys(this.state.amenitiesGroup).map((key) => (
                              <Fragment key={key}>
                                <div className="has-text-grey filter-subtitle">{key}</div>
                                {this.state.amenitiesGroup[key].map(item => (
                                  <Checkbox
                                    checked={this.state.amenities.indexOf(item.uid) !== -1}
                                    onChange={e => this.handleCheckedChange(e, 'amenities')}
                                    value={item.uid}
                                    key={item.uid}>
                                    {item.name}
                                  </Checkbox>
                                ))}
                              </Fragment>
                            ))
                          }
                        </div>
                      </Fragment> :
                      <Fragment>
                        <h3 className="filter-title">Preferred Tenant</h3>
                        <div className="filter-options">
                          <RadioGroup selectedValue={this.state.customerPreference}>
                            {
                              tenantType.map((item, i) => (
                                <Radio label={item.tenant} value={item.id} key={item.id}
                                  onClick={e => this.handleRadioChange(e, 'customerPreference')}
                                />
                              ))
                            }
                          </RadioGroup>
                        </div>
                        <h3 className="filter-title">Furnishing</h3>
                        <div className="filter-options">
                          <RadioGroup selectedValue={this.state.furnishType}>
                            {
                              furnishedType.map((item, i) => (
                                <Radio label={item.furnishing} value={item.id} key={item.id}
                                  onClick={e => this.handleRadioChange(e, 'furnishType')}
                                />
                              ))
                            }
                          </RadioGroup>
                        </div>
                      </Fragment>
                    }
                  </div>
                </Card>
              </div>
              <div className="column">
                {
                  !this.state.searchData ?
                    <div className="has-text-centered has-text-grey-light search-loader">
                      <FontAwesomeIcon icon={faCircleNotch} spin size="4x" />
                    </div> :
                    <div>
                      {
                        this.state.searchData.length ?
                          this.state.searchData.map((item, i) => (
                            <SearchResultCard data={item} history={this.props.history} key={`${i}`} />
                          )) :
                          <div className="has-text-centered" style={{ paddingTop: 50, paddinBottom: 50 }}>
                            <p className="has-text-grey-light is-size-4" style={{ marginBottom: 20 }}>No Properties Found</p>
                            <p className="has-text-grey" style={{ marginBottom: 5 }}>Try again with different Filters</p>
                            <p style={{ marginBottom: 5 }}><strong>or</strong></p>
                            <p>
                              <Link to="/">Search for a different Location</Link>
                            </p>
                          </div>
                      }
                    </div>
                }
              </div>
            </div>
          </div>
        </section>
      </Page>
    );
  }
}

export default withRouter(SearchResult);


// WEBPACK FOOTER //
// ./src/app/components/search-result/index.js